import React from 'react';

import { BasicDialog } from 'library';
import ReviewProvider from 'parent-portal/provider-reviews/ReviewProvider';

export type PromptType = 'block' | 'prefer';

export function PromptForReviewModal({
    open,
    onClose,
    userId,
    promptedByActionType,
}: {
    open: boolean;
    onClose: () => void;
    userId?: number;
    promptedByActionType?: PromptType;
}) {
    return (
        <BasicDialog
            isOpen={open}
            onClose={() => {
                onClose();
            }}
            closeButton
        >
            <ReviewProvider promptedByActionType={promptedByActionType} userId={userId} />
        </BasicDialog>
    );
}
